<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">All Bills</h4>
                                <h6 class="card-subtitle">Search bills by status, customer</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'add-marketplace-bill'}"
                                                     class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New Bill
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-3">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('partner')}"
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="true"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="buyers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @input="selectBuyer()"
                                            @search-change="searchBuyers"
                                            class="form-control multiselect-sm"
                                            data-vv-as="buyer"
                                            id="buyer"
                                            label="buyer"
                                            name="buyer"
                                            open-direction="bottom"
                                            placeholder="Search Buyer"
                                            track-by="id"
                                            v-if="currentOrg.type === 'COOP'"
                                            v-model="buyer"
                                            v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :max-height="600"
                                            :options="sellers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            @search-change="searchSellers"
                                            class="form-control  multiselect-sm"
                                            id="seller"
                                            label="seller"
                                            name="seller"
                                            open-direction="bottom"
                                            placeholder="Search Seller"
                                            v-if="currentOrg.type === 'COOP_MEMBER'"
                                            v-model="filter.seller">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Seller not found</span>
                                    </multiselect>
                                </div>
                                <div class="col-3">
                                    <multiselect
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="true"
                                            :limit="3"
                                            :max-height="600"
                                            :options="members"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchMembers"
                                            class="form-control multiselect-sm"
                                            data-vv-as="did"
                                            id="did"
                                            label="short_name"
                                            name="member_id"
                                            open-direction="bottom"
                                            placeholder="Search Member"
                                            track-by="did"
                                            v-model="filter.member">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.short_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.short_name }}</h5>
                                                <div>{{ props.option.did | hex_format(10, '.....') }}</div>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-2">
                                    <select class="custom-select" id="inlineFormCustomSelect"
                                            v-model="filter.status">
                                        <option :value="null">Choose Status</option>
                                        <option
                                                v-bind:key="index"
                                                v-bind:value="s"
                                                v-for="(s, index) in statuses">{{s | capitalize}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-3">
                                    <input
                                            class="form-control"
                                            name="purchase"
                                            placeholder="Bill #"
                                            type="text"
                                            v-model="filter.number">
                                </div>

                            </div>

                            <div class="form-group row">
                                <div class="col-2">
                                    <input class="form-control" id="startdate" placeholder="Start Date" type="text"/>
                                </div>

                                <div class="col-2">
                                    <input class="form-control" id="enddate" placeholder="End Date" type="text"/>
                                </div>
                                <div class="col-2">
                                    <div class="btn-group" style="display: flex;">
                                        <button @click="getBills(1)"
                                                class="btn btn-light btn-outline-success font-weight-bold"
                                                style="flex: 1"
                                                type="button">
                                            <i class="fa fa-search"/> Go!
                                        </button>
                                        <button @click="reset()"
                                                class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                                style="flex: 1" type="button">
                                            <i class="fa fa-undo"/> Reset
                                        </button>
                                    </div>
                                </div>


                                <div class="col-2 text-right ml-auto">
                                    <!--                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" title="Exporting, please wait ...">-->
                                    <!--                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>-->
                                    <!--                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>-->
                                    <!--                                        </span>-->
                                    <button aria-expanded="false" aria-haspopup="true"
                                            class="btn waves-effect waves-light btn-outline-info"
                                            data-toggle="dropdown" title="Operations">
                                        <i class="fa fa-grip-vertical"/>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="javascript:void(0)">
                                            <json-c-s-v
                                                    :data="exportedBills"
                                                    :name="'Bill Report.csv'">
                                                Export as CSV
                                            </json-c-s-v>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive m-t-30" v-if="bills.length>0">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="col-form-label" for="records" style="padding-left: 10px;">Display
                                        Maximum</label>
                                    <div class="col-sm-2" style="padding-top: 5px;">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt"
                                                class="form-control form-control-sm" id="records" name="lang_opt_length"
                                                v-model="perPage">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>
                                </div>
                            </div>
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0" style="width: 0px;">
                                        <div class="form-check">
                                            <input
                                                    @change="checkAll($event)"
                                                    class="form-check-input"
                                                    id="checkAll"
                                                    type="checkbox">
                                            <label class="form-check-label" for="checkAll"></label>
                                        </div>
                                    </th>
                                    <th class="border-0"><h6>#</h6></th>
                                    <th class="border-0"><h6>Status</h6></th>
                                    <th class="border-0"><h6>Buyer</h6></th>
                                    <th class="border-0"><h6>Goods/Services</h6></th>
                                    <th class="border-0"><h6>Total</h6></th>
                                    <th class="border-0"><h6>Due At</h6></th>
                                    <th class="border-0 text-center"><h6>Actions</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(bill, index) in bills">
                                    <td class="sorting_1">
                                        <div class="form-check">
                                            <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    v-bind:id="bill.id"
                                                    v-bind:value="bill"
                                                    v-model="checkedBills">
                                            <label class="form-check-label" v-bind:for="bill.id"></label>
                                        </div>
                                    </td>
                                    <td>{{index+1}}</td>
                                    <td>
                                        <p v-if="bill.status === 'UNPAID'"><span class="label label-cyan">Unpaid</span>
                                        </p>
                                        <p v-if="bill.status === 'PAID'"><span
                                                class="label label-dark-green">Paid</span></p>
                                    </td>
                                    <!--                                    <td>{{bill.invoice_number}}</td>-->
                                    <td v-if="bill.member_did && bill.member_catalog">
                                        <did-details :catalog="bill.member_catalog" :did="bill.member_did"
                                                     :show_blockie="true"></did-details>
                                    </td>
                                    <td v-else>
                                        <blockie :address="bill.partner.biz_email"/>
                                        {{bill.partner.biz_name | capitalize}}
                                    </td>
                                    <td>
                                        <ul>
                                            <li v-bind:key="index" v-for="(item, index) in bill.bill_items">
                                                {{item.goods_services}}
                                            </li>
                                        </ul>
                                    </td>
                                    <td>{{bill.total | money}}</td>
                                    <td>{{bill.due_at | medium}}</td>
                                    <td class="text-center">
                                        <h6>
                                            <router-link
                                                    :to="{name: 'view-marketplace-bill', params : { billid: bill.id}}"
                                                    class="ml-3"
                                                    title="Details">
                                                <i class="fa fa-eye"/>
                                            </router-link>
                                            <router-link
                                                    :to="{name: 'edit-marketplace-bill', params : { billid: bill.id}}"
                                                    class="text-info ml-3" title="Edit"
                                                    v-if="bill.status === 'UNPAID'">
                                                <i class="fa fa-edit"/>
                                            </router-link>
                                            <a @click="bill_to_remove = bill.id" class="text-danger ml-3"
                                               data-target="#deleteModal"
                                               data-toggle="modal" href="javascript:void(0)" title="Delete"
                                               v-if="bill.status === 'UNPAID'">
                                                <i class="fa fa-trash-alt"/>
                                            </a>
                                        </h6>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <div class="hide" id="invoice-summary-table">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Invoice Id</th>
                                        <th>Partner</th>
                                        <th>Status</th>
                                        <th>Price</th>
                                        <th>Created at</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="card-body" v-else>
                            <h4 class="card-title text-muted text-center">No records found</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>

        <div aria-hidden="true" aria-labelledby="deleteModal" class="modal fade" id="deleteModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="text-center m-t-20 m-b-10">
                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                            <br><br>
                            <h4>Are you sure you want to remove this Bill?</h4>
                            <button @click="removeBill" class="btn waves-effect waves-light btn-success m-r-15"
                                    data-dismiss="modal" type="button">Yes
                            </button>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    import _ from 'lodash';
    import JsonCSV from 'vue-json-csv';
    import DidDetails from "../../common/DidDetails";

    export default {
        name: "Bills",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {DidDetails, Blockie, Multiselect, Paginate, JsonCSV},
        data() {
            return {
                submitted: false,
                isLoading: false,
                statuses: ['UNPAID', 'PAID'],
                buyers: [],
                sellers: [],
                members: [],
                filter: {
                    buyer_id: null,
                    member: null,
                    status: null,
                    start: null,
                    end: null,
                    number: null
                },
                buyer: null,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                bills: [],
                pageCount: 1,
                total: 0,
                opens: 'right',
                value: true,
                checkedBills: [],
                exportedBills: [],
                inv_export_name: "Invoice_Report.csv",
                perPage: 10,
                isFiltered: false,
                bill_to_remove: null
            }
        },
        mounted() {
            this.init();

            let self = this;
            $(function () {
                $('#startdate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.filter.start = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.filter.start = null;
                        }
                    });

                $('#enddate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.filter.end = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.filter.end = null;
                        }
                    });
            });
        },
        methods: {
            async init() {
                await this.getBills(1);
            },
            async searchMembers(searchText) {
                let {data} = await this.$identity.get(`/identity/controller/dids?page=0&per_page=1000`);
                this.members = data.dids;
            },
            perPageRecordChange() {
                if (this.isFiltered) {
                    this.searchBills(1);
                } else {
                    this.getBills(1);
                }
            },
            async getBills(page) {
                try {
                    $(".preloader").fadeIn();
                    this.filter.member = this.filter.member ? this.filter.member.did : null;
                    let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/bills`, {
                        params: {
                            page: page,
                            perPage: this.perPage,
                            ...this.filter
                        }
                    });
                    $(".preloader").fadeOut();

                    this.isFiltered = false;
                    this.total = reply.data.total;
                    this.bills = reply.data.bills;
                    this.exportedBills = reply.data.bills.map(s => ({
                        number: s.bill_number,
                        status: s.status,
                        partner: s.partner.biz_name,
                        total: s.total.currency_symbol + ' ' + s.total.amount,
                        created_at: moment(s.created_at).format("MMMM Do YYYY"),
                        due_at: moment(s.due_at).format("MMMM Do YYYY")
                    }))
                    let max_date = reply.data.min_date;
                    let min_date = reply.data.max_date;
                    if (min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate = moment(min_date).format('YYYY-MM-DD');
                    } else if (this.bills.length === 1) {
                        this.startDate = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                        this.endDate = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.setPageCount();
                } catch (e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getBills(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            checkAll(e) {
                if (e.target.checked) {
                    this.checkedBills = this.invoices
                } else {
                    this.checkedBills = []
                }
            },
            change(e) {
                this.filter.start = e[0].toDate();
                this.filter.end = e[1].toDate();
            },
            async searchBuyers(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/bills/buyer/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.buyers = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchSellers(searchText) {
                try {
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/bills/seller/search`, {
                            params: {
                                search: searchText
                            }
                        });
                    this.sellers = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            selectBuyer() {
                this.filter.buyer_id = this.buyer.org_id;
            },
            reset() {
                this.filter = {
                    buyer: null,
                    seller: null,
                    member: null,
                    status: null,
                    start: "",
                    end: "",
                    number: ""
                }
                this.getBills(1);
            },
            async searchBills(page) {
                try {
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/bills/${JSON.stringify(this.filter)}`, {
                            params: {
                                page: page,
                                perPage: this.perPage
                            }
                        });
                    this.total = reply.data.total;
                    this.bills = reply.data.bills;
                    let max_date = reply.data.min_date;
                    let min_date = reply.data.max_date;
                    if (min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate = moment(min_date).format('YYYY-MM-DD');
                    } else if (this.bills.length === 1) {
                        this.startDate = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                        this.endDate = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.isFiltered = true;
                    this.setPageCount();
                } catch (e) {
                    console.log(e);
                }
            },
            async removeBill() {
                try {
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/bills/${this.bill_to_remove}`);
                    this.$toastr('success', 'Bill deleted', 'Success');
                    await this.getBills(1);
                } catch (e) {
                    this.$toastr('error', e.response.data.reason, 'Failed');
                }
            }
        }
    }
</script>

<style scoped>

</style>
